import React from 'react';
import TranslateAddIcon from 'material-ui-icons/NoteAdd';
import {
    IconButton,
    Tooltip
} from 'material-ui';
import {
    showAddNewTranslationButton,
} from '../../components/permissions/permissions';

const TranslationsTableItemActionAdd = ({
    classes,
    menu,
    sites,
    handleClickOpen
}) => {

    const AddTranslationButton = showAddNewTranslationButton(() =>
        <span className={classes.tableIconBtn}>
            <Tooltip title="Add Menu Translation">
                <IconButton className="smallIconButton editColor" onClick={e => handleClickOpen(menu.id)}>
                    <TranslateAddIcon />
                </IconButton>
            </Tooltip>
        </span>
    )

    return (
        <AddTranslationButton/>
    )
};

export default TranslationsTableItemActionAdd;




// WEBPACK FOOTER //
// ./src/containers/menus/MenusTableItemActionAddTranslation.jsx